import Keycloak from "keycloak-js";

const BASE_URL =
  process.env.VITE_API_BASE_URL === "https://pcs.fujairahport.ae"
    ? "https://pcs.fujairahport.ae"
    : "https://pcs-dev.fujairahport.ae";

const keycloak = new Keycloak({
  url: `${BASE_URL}/keycloak`,
  realm: "PoFPCS",
  clientId: "pcs-spa",
});

export default keycloak;
